import axios from 'axios'

import {
  identify,
  registerSuperProperties,
  reset,
  unregisterSuperProperty,
} from '@/posthog'
import store from '@/stores'

import DialogoServico from './DialogoServico'

const LOGIN_URL = process.env.VUE_APP_API_URL + '/login'
const dialogoServico = new DialogoServico()

class Autenticacao {
  sincronizarIdentidadePosthog(backendVersion = null) {
    const usuarioLogado = this.getUsuario()
    const distinctId = usuarioLogado && usuarioLogado._id

    if (!distinctId) {
      return
    }

    identify(
      distinctId,
      {
        email: usuarioLogado.email,
        name: usuarioLogado.nome,
        role: usuarioLogado.perfil,
      },
      { first_login_at: usuarioLogado.ultimoLogin }
    )

    registerSuperProperties({
      user_role: usuarioLogado.perfil,
      backend_version: backendVersion,
    })
  }

  enviarNovaSenha(dados) {
    return axios.post(
      process.env.VUE_APP_API_URL + '/usuario/recuperacao-senha/nova',
      dados
    )
  }

  solicitarNovaSenha(email) {
    return axios.post(
      process.env.VUE_APP_API_URL + '/usuario/recuperacao-senha',
      {
        email,
      }
    )
  }

  verificarTokenParaNovaSenha(token) {
    return axios.get(
      `${process.env.VUE_APP_API_URL}/usuario/recuperacao-senha/${token}`
    )
  }

  login(usuario) {
    store.setCarregando()
    return axios
      .post(LOGIN_URL, usuario)
      .then((data) => {
        localStorage.setItem('tactus-token', data.data.token)
        store.setAutenticado(true)
        const usuarioLogado = this.getUsuario()
        store.setUsuario(usuarioLogado)
        store.setVersaoBackend(data.data.versaoBackend)
        this.sincronizarIdentidadePosthog(data.data.versaoBackend)
        store.setCarregando()
      })
      .catch((err) => {
        this.logout()
        store.setCarregando()
        if (err.response) {
          dialogoServico.alerta({
            title: err.response.status,
            content: err.response.data.msg,
          })
        } else {
          const msgErro =
            'Não foi possível conectar com o servidor, contate o administrador.'
          dialogoServico.alerta({
            title: 'Erro',
            message: msgErro,
          })
        }
      })
  }

  logout({ resetPosthog = true } = {}) {
    store.setCarregando()

    unregisterSuperProperty('user_role')

    if (resetPosthog) {
      reset(true)
    }

    localStorage.removeItem('tactus-token')
    store.setAutenticado(false)
    store.setCarregando()
  }

  verificaAutenticacao() {
    store.setAutenticado(!!localStorage.getItem('tactus-token'))
  }

  getAuthHeader() {
    return {
      Authorization: 'Bearer ' + this.getToken(),
    }
  }

  getToken() {
    return localStorage.getItem('tactus-token')
  }

  getUsuario() {
    const token = localStorage.getItem('tactus-token')

    if (token) {
      var payload = token.split('.')[1]
      payload = window.atob(payload)
      payload = JSON.parse(payload)
      return {
        ultimoLogin: payload.ultimoLogin,
        perfil: payload.perfil,
        email: payload.email,
        nome: payload.name,
        _id: payload._id,
      }
    } else {
      return {}
    }
  }
}

export default Autenticacao
